// extracted by mini-css-extract-plugin
module.exports =  {"group-title":"editSelectedModal__group-title"};